import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { checkUnsavedChanges } from '../../store/actions';
import { UnsavedChangesService } from '../services/unsaved-changes.service';

export const unsavedChangesGuard: CanDeactivateFn<unknown> = (
  _component,
  _currentRoute,
  _currentState,
  nextState,
): boolean => {
  const store = inject(Store);
  const unsavedChangesService = inject(UnsavedChangesService);

  if (!unsavedChangesService.hasUnsavedChanges()) {
    return true;
  }

  store.dispatch(checkUnsavedChanges({ targetUrl: nextState?.url || '/' }));

  return false;
};
